import { render, staticRenderFns } from "./AccountBind.vue?vue&type=template&id=4377332c&scoped=true&"
import script from "./AccountBind.vue?vue&type=script&lang=js&"
export * from "./AccountBind.vue?vue&type=script&lang=js&"
import style0 from "./AccountBind.vue?vue&type=style&index=0&id=4377332c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377332c",
  null
  
)

export default component.exports